@if (authService.isAuthenticated$ | async) {
  <div class="container pt-5 pb-4">
    <div class="row justify-content-around">
      <div class="col-3">
        <ul>
          <li><a target="_blank" href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/1689518">NMLS Consumer Access #1689518</a></li>
          <li><a target="_blank" href="https://www.securechoicelending.com/state-licencing/">Licensing Disclaimer</a></li>
          <li><a target="_blank" href="https://www.securechoicelending.com/texas-complaint-notice-and-servicing-disclosure/">Texas Complaint Notice and Servicing Disclosure</a></li>
        </ul>
      </div>
      <div class="col-3">
        <ul>
          <li><a [routerLink]="['/privacy-policy']">Privacy Policy</a></li>
          <li><a [routerLink]="['/terms-of-use']">Terms Of Use</a></li>
          <li>
            <p>Connect with SCL on Social Media</p>
            <ul class="d-flex social-media justify-content-between">
              <li><a target="_blank" href="https://www.facebook.com/securechoicelending"><i class="fa-brands fa-facebook"></i></a></li>
              <li><a target="_blank" href="https://twitter.com/secure_choice"><i class="fa-brands fa-x-twitter"></i></a></li>
              <li><a target="_blank" href="https://www.linkedin.com/company/secure-choice-lending/"><i class="fa-brands fa-linkedin"></i></a>
              <li><a target="_blank" href="https://www.instagram.com/securechoicelending/"><i class="fa-brands fa-instagram"></i></a></li>
              <li><a target="_blank" href="https://www.youtube.com/channel/UCVdx2WNCT_Otbz2ErNhM61A"><i class="fa-brands fa-youtube"></i></a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="ftb">
    <div class="container">
      <div class="d-flex justify-content-center text-white py-3">
        <span class="mr-5">COPYRIGHT {{currentDate | date:'yyyy'}}</span>
        <span>•</span>
        <span class="mx-5">SECURE CHOICE LENDING</span>
        <span>•</span>
        <span class="mx-5">
          ALL RIGHTS RESERVED.
        </span>
        <img class="ehl" src="/assets/images/equalhousinglender.png" alt="Equal Housing Lender" />
      </div>
    </div>
  </div>
}


